import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../constants/queryKeys';
import ApiService from '../../services/api';

const WORKSPACE_STALE_MS = 3 * 60_000;

export function useMsmeProfileQuery(enabled = true) {
  return useQuery({
    queryKey: queryKeys.msme.profile,
    queryFn: () => ApiService.getMSMEProfile(),
    enabled,
    staleTime: WORKSPACE_STALE_MS,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      const status = (error as { status?: number; response?: { status?: number } })?.status
        ?? (error as { response?: { status?: number } })?.response?.status;
      if (status && status < 500) {
        return false;
      }
      return failureCount < 1;
    },
  });
}

export function useMsmeStatsQuery(enabled = true) {
  return useQuery({
    queryKey: queryKeys.msme.stats,
    queryFn: async () => {
      try {
        return await ApiService.getMSMEStats();
      } catch {
        return null;
      }
    },
    enabled,
    staleTime: WORKSPACE_STALE_MS,
    refetchOnWindowFocus: false,
  });
}
